import React from 'react';

import PropTypes from 'prop-types';

import { Col, Row, Typography, VertContainer, VertTypography } from '@vertem-core/vertice-ds'

import 'Assets/styles/default/pages/concierge/ManageConciergeSolicitationStyles.less';

import { getLocalizedDate } from 'Utils/format';

import { StepStatusEnum } from 'pages/ManageConciergeSolicitationPage/enum/action-enum';

const ManageConciergeActionHistory = ({ ...props }) => {
    const {
        actionHistory
    } = props;

    const wrapperStatusColor = (status) => {
        switch (status) {
            case StepStatusEnum.Canceled:
                return "concierge-history-canceled";
            case StepStatusEnum.Approved:
                return "concierge-history-concluded";
            case StepStatusEnum.Pending:
                return "concierge-history-pending";
            case StepStatusEnum.InApproval:
                return "concierge-history-in-approval";
        }
    }

    const getAuthor = (author) => {
        return author == "admin" ? "Operação Vertem" : author;
    }

    const getActionNote = (stepPosition, { status, approvedBy }) => {
        if (stepPosition == 0)
            return `Solicitação criada por ${getAuthor(approvedBy)}`;

        if (status === StepStatusEnum.Approved)
            return `Etapa concluída por ${getAuthor(approvedBy)}`;

        if (status === StepStatusEnum.Canceled)
            return `Solicitação cancelada por ${getAuthor(approvedBy)}`;
    
        if (status === StepStatusEnum.InApproval)
            return (
                <span className="span-status-description">
                    Etapa em aprovação
                </span>
            );
    }

    const actionHasNote = (stepPosition, { status, note }) => {
        if (status != StepStatusEnum.Approved || !note) return false;
        if (stepPosition == 0) return false;

        return note !== "n/i";
    }

    const actionHasMotivation = ({ status }) => {
        return status == StepStatusEnum.Canceled;
    }

    return (
        <>
            <div className='margin-top-small'>
                <Typography.Text className='details-card-title'>
                    Últimas atualizações
                </Typography.Text>
            </div>

            <Row>
                <Col md={24} lg={12}>
                    <Row className='container-solicitation-status'>
                        {
                            (actionHistory.listActions && actionHistory.listActions.length) ?
                                <>
                                    <Col span={24}>
                                        <Typography.Text className='solicitation-status-title'>
                                            Etapa atual da solicitação:
                                        </Typography.Text>
                                        <Typography.Text className='details-card-subtitle'>
                                            {actionHistory.solicitationStatusDescription}
                                        </Typography.Text>
                                    </Col>

                                    <div className='container-last-actions'>
                                        {
                                            actionHistory.listActions.map((action, index) => (
                                                <VertContainer
                                                    className={
                                                        `concierge-history-actions 
                                                        ${index != actionHistory.listActions.length - 1 ?
                                                            'concierge-history-action-item' :
                                                            'concierge-history-last-action'}
                                                        ${wrapperStatusColor(action.status)}`
                                                    }
                                                >
                                                    <div className='container-actions-history-main'>
                                                        <div className='container-actions-history-sub'>
                                                            <Typography.Text className='span-status-date'>
                                                                {`${action.statusDescription}`}
                                                            </Typography.Text>
                                                            {
                                                                action.date &&
                                                                    <Typography.Text className='span-date-history'>
                                                                        {`${getLocalizedDate(action.date)}`}
                                                                    </Typography.Text>
                                                            }
                                                        </div>

                                                        {
                                                            action.status !== StepStatusEnum.Pending && (
                                                                <Typography.Text>
                                                                    {getActionNote(index, action)}
                                                                </Typography.Text>
                                                            )
                                                        }

                                                        {
                                                            actionHasNote(index, action) && (
                                                                <VertTypography.Paragraph className="action-note">
                                                                    <span>Comentário: </span><span className="muted">{action.note}</span>
                                                                </VertTypography.Paragraph> 
                                                            )
                                                        }

                                                        {
                                                            actionHasMotivation(action) && (
                                                                <VertTypography.Paragraph className="action-motivation">
                                                                    <span>Motivo: </span><span className="muted">{action.note}</span>
                                                                </VertTypography.Paragraph>
                                                            )
                                                        }
                                                    </div>
                                                </VertContainer>
                                            ))}
                                    </div>
                                </>
                                :
                                <div className='container-action-history-empty'>
                                    Nenhuma atualização
                                </div>
                        }
                    </Row>
                </Col>
            </Row>
        </>
    )
}

ManageConciergeActionHistory.propTypes = {
    actionHistory: PropTypes.object.isRequired
};

export default ManageConciergeActionHistory;